(function() {
  'use strict';

  var burger = document.querySelector('[data-nav-open]');
  var mMenu = document.querySelector('.m-menu');
  var mClose = document.querySelector('[data-nav-close]');
  if (burger && mMenu) burger.addEventListener('click', function() { mMenu.classList.add('open'); document.body.style.overflow = 'hidden'; });
  if (mClose && mMenu) mClose.addEventListener('click', function() { mMenu.classList.remove('open'); document.body.style.overflow = ''; });

  var cartOpeners = document.querySelectorAll('[data-cart-open]');
  var drawer = document.querySelector('.drawer');
  var overlay = document.querySelector('.drawer-overlay');
  var cartClose = document.querySelectorAll('[data-cart-close]');

  function openCart() {
    if (drawer) drawer.classList.add('open');
    if (overlay) overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (drawer) drawer.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
    document.body.style.overflow = '';
  }
  cartOpeners.forEach(function(b) { b.addEventListener('click', function(e) { e.preventDefault(); openCart(); }); });
  cartClose.forEach(function(b) { b.addEventListener('click', closeCart); });

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function(el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function(el) { el.classList.add('in'); });
  }

  document.querySelectorAll('.qty').forEach(function(w) {
    var input = w.querySelector('input');
    var minus = w.querySelector('[data-qty-m]');
    var plus = w.querySelector('[data-qty-p]');
    if (minus) minus.addEventListener('click', function() {
      var v = parseInt(input.value, 10) || 1;
      if (v > 1) input.value = v - 1;
    });
    if (plus) plus.addEventListener('click', function() {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  });

  document.querySelectorAll('[data-gallery]').forEach(function(g) {
    var main = g.querySelector('[data-main-img]');
    var thumbs = g.querySelectorAll('[data-thumb]');
    thumbs.forEach(function(t) {
      t.addEventListener('click', function() {
        var src = t.dataset.src;
        if (main && src) main.src = src;
        thumbs.forEach(function(x) { x.classList.remove('active'); });
        t.classList.add('active');
      });
    });
  });

  document.querySelectorAll('[data-variant-group]').forEach(function(group) {
    var chips = group.querySelectorAll('.variant-chip');
    chips.forEach(function(c) {
      c.addEventListener('click', function(e) {
        e.preventDefault();
        chips.forEach(function(x) { x.classList.remove('selected'); });
        c.classList.add('selected');
      });
    });
  });

  document.querySelectorAll('[data-product-form]').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var fd = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: fd,
        headers: { 'Accept': 'application/json' }
      }).then(function(r) {
        if (r.ok) { refreshCart().then(openCart); }
      }).catch(function(err) { console.error(err); });
    });
  });

  function refreshCart() {
    return fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      var count = document.querySelector('.cart-count');
      if (count) {
        count.textContent = cart.item_count;
        count.style.display = cart.item_count > 0 ? 'flex' : 'none';
      }
      var body = document.querySelector('[data-drawer-body]');
      if (body) {
        if (!cart.items.length) {
          body.innerHTML = '<div class="cart-empty">Votre panier est vide</div>';
        } else {
          body.innerHTML = cart.items.map(function(it) {
            return '<div class="line-item">' +
              '<img src="' + it.image + '" alt="">' +
              '<div class="line-item-info"><h4>' + it.product_title + '</h4>' +
              '<p>Qté : ' + it.quantity + '</p></div>' +
              '<div class="line-item-price">' + (it.final_line_price / 100).toFixed(2) + ' CHF</div>' +
              '</div>';
          }).join('');
        }
      }
      var total = document.querySelector('[data-drawer-total]');
      if (total) total.textContent = (cart.total_price / 100).toFixed(2) + ' CHF';
    });
  }

  window.shopTheme = { openCart: openCart, closeCart: closeCart, refreshCart: refreshCart };
})();
